// mock RHNTMLtoPDF for web version, because react-native-html-to-pdf is not supported for web
// alternative used for web is jsPDF
import { Fragment as RHNTMLtoPDF } from 'react';

export default RHNTMLtoPDF;
